var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgBicchieriIcon = function SvgBicchieriIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 314 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.04 39.46c1.049-5.942 6.252-10.464 12.503-10.464 6.252 0 11.732 4.759 12.582 10.939.08.572-25.203.237-25.085-.474Z",
    fill: "#A32F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m201.792 38.632-.217 2.31 1.206 3.574 1.86 2.37 3.383 2.428 2.631.928 3.403.335 2.136-.177 3.522-1.481 2.651-2.014 2.394-3.357 1.444-4.285s-6.034-1.164-6.173-1.204c-.138-.04-15.787-.889-15.787-.889l-2.492 1.442.039.02Z",
    fill: "#A32F28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.066 38.06c0 6.91-5.618 12.517-12.542 12.517-6.924 0-12.543-5.607-12.543-12.518M201.001 38.059c0-2.665 1.741-8.648 2.097-10.445.613-3.14.435-8.59.435-8.59",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.567 49.926s3.957 1.698 3.977 5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 49.926s-3.957 1.698-3.976 5.41M226.066 38.059c0-2.665-1.741-8.648-2.097-10.445-.613-3.14-.435-8.59-.435-8.59M213.543 55.356v18.856M213.544 87.639c5.517 0 9.99-4.465 9.99-9.971 0-5.507-4.473-9.972-9.99-9.972-5.518 0-9.991 4.465-9.991 9.972 0 5.506 4.473 9.97 9.991 9.97Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.567 78.714s3.957-1.698 3.977-5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 78.714s-3.957-1.698-3.976-5.41M213.544 29.016c5.517 0 9.99-4.464 9.99-9.971s-4.473-9.972-9.99-9.972c-5.518 0-9.991 4.465-9.991 9.972s4.473 9.97 9.991 9.97Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.86 39.343c5.463 0 9.892-4.42 9.892-9.873 0-5.453-4.429-9.872-9.892-9.872-5.463 0-9.891 4.42-9.891 9.872s4.428 9.873 9.891 9.873Z",
    fill: "#DB6D5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m80.245 29.233-.593 3.436.593 5.35 2.295 3.022 3.581 2.942 2.631 2.448 1.029 1.896 1.207-2.153 4.352-3.317 2.413-2.784 1.998-3.91.376-4.66-.296-2.27-6.113-.336-13.473.336Z",
    fill: "#DB6D5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.804 78.359s3.957-1.698 3.977-5.41M93.757 78.359s-3.957-1.698-3.976-5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.86 86.869c4.85 0 8.784-3.925 8.784-8.767s-3.933-8.767-8.784-8.767c-4.851 0-8.784 3.925-8.784 8.767s3.933 8.767 8.784 8.767Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.452 16.774s-3.205 14.73-1.048 20.515c2.987 8.017 9.377 5.548 9.377 13.348v23.22M98.11 16.774s3.204 14.73 1.048 20.515c-2.987 8.017-9.377 5.548-9.377 13.348",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.86 28.206c4.85 0 8.784-3.925 8.784-8.767 0-4.841-3.933-8.766-8.784-8.766-4.851 0-8.784 3.925-8.784 8.766 0 4.842 3.933 8.767 8.784 8.767Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.046 56.323c7.069 0 12.8-5.57 12.8-12.44 0-6.87-5.731-12.439-12.8-12.439-7.07 0-12.8 5.57-12.8 12.44 0 6.87 5.73 12.44 12.8 12.44Z",
    fill: "#8D2215"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.984 43.153c0 7.148-5.797 12.933-12.958 12.933-7.162 0-12.958-5.785-12.958-12.933M38.087 43.153c-.059-3.02.851-7.898 1.207-9.754.633-3.238 2.038-12.854 2.038-12.854",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.988 55.908s2.058.178 2.058 3.18M51.026 58.93v18.165M51.046 89.06c5.353 0 9.693-4.331 9.693-9.675 0-5.343-4.34-9.675-9.693-9.675-5.354 0-9.694 4.332-9.694 9.675 0 5.344 4.34 9.675 9.694 9.675ZM63.983 43.153c.06-3.02-.85-7.898-1.206-9.754-.633-3.238-2.038-12.854-2.038-12.854",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.083 55.908s-2.057.178-2.057 3.18M53.083 80.076s-2.057-.177-2.057-3.178",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.988 80.076s2.058-.177 2.058-3.178M51.046 31.445c5.353 0 9.693-4.332 9.693-9.676 0-5.343-4.34-9.675-9.693-9.675-5.354 0-9.694 4.332-9.694 9.675 0 5.344 4.34 9.676 9.694 9.676Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M243.198 40.093c2.829-5.173 8.309-8.688 14.64-8.688 6.33 0 11.652 3.416 14.501 8.47 1.365 2.41-30.427 2.587-29.141.237v-.02Z",
    fill: "#8D2215"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m243.653 40.409 2.156 3.14 2.968 2.33 4.135 1.914 3.877 2.449 1.128 1.224 1.503-1.659 3.917-2.211s5.361-2.073 5.421-2.251c.059-.178 2.354-3.16 2.354-3.16l1.029-1.875-4.135-2.192-15.154-.533-9.219 2.784.02.04Z",
    fill: "#8D2215"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.936 48.76c-11.454-1.263-15.569-7.167-15.569-14.077",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.367 34.702c0-2.665 1.741-8.648 2.097-10.445.613-3.14.455-10.247.455-10.247M253.96 48.01s3.957 1.699 3.977 5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M261.893 48.01s-3.956 1.699-3.976 5.41M257.937 51.98v18.856M257.937 87.895c6.785 0 12.285-5.49 12.285-12.261 0-6.772-5.5-12.262-12.285-12.262s-12.286 5.49-12.286 12.262 5.501 12.261 12.286 12.261Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.96 75.338s3.957-1.698 3.977-5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M261.893 75.338s-3.956-1.698-3.976-5.41M257.679 48.76c11.455-1.263 15.57-7.167 15.57-14.077",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.249 34.702c0-2.665-1.741-8.648-2.097-10.445-.614-3.14-.455-10.247-.455-10.247",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M257.838 27.673c7.134 0 12.918-5.772 12.918-12.893s-5.784-12.894-12.918-12.894c-7.135 0-12.919 5.773-12.919 12.894 0 7.12 5.784 12.893 12.919 12.893Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M291.113 34.604v3.416l1.484 3.297 3.58 4.443 2.928 3.337 2.018 3.297 1.504-2.567 4.154-4.502 2.789-3.514 2.216-4.838-1.424-3.752-3.581-3.573-4.55-1.54-5.421.829-4.945 4.245-.752 1.422Z",
    fill: "#D03029",
    stroke: "#D03029",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M294.041 38.276c0-.75-3.719-.869-3.561-1.56a10.846 10.846 0 0 1 10.643-8.648c5.262 0 9.773 3.85 10.683 8.925.119.632-17.746 7.286-17.746 1.303l-.019-.02Z",
    stroke: "#D03029",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M297.167 78.793s3.956-2.685 3.976-8.53",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M305.099 78.793s-3.956-2.685-3.976-8.53",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M301.103 88.31c5.332 0 9.655-4.314 9.655-9.636 0-5.321-4.323-9.635-9.655-9.635-5.331 0-9.654 4.314-9.654 9.635 0 5.322 4.323 9.636 9.654 9.636Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M293.665 16.794s-5.598 12.044-3.244 19.843c2.631 8.708 10.544 11.373 10.702 17.455v19.784M308.581 16.794s5.599 12.044 3.245 19.843c-2.632 8.708-10.545 11.373-10.703 17.455",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M301.103 27.357c4.371 0 7.913-3.536 7.913-7.898s-3.542-7.898-7.913-7.898c-4.37 0-7.913 3.536-7.913 7.898s3.543 7.898 7.913 7.898Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.281 40.507c5.463 0 9.892-4.42 9.892-9.872 0-5.453-4.429-9.873-9.892-9.873-5.463 0-9.891 4.42-9.891 9.873 0 5.452 4.428 9.872 9.891 9.872Z",
    fill: "#D12C46"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m1.667 30.398-.594 3.436.594 5.35 2.294 3.022 3.581 2.941 2.651 2.449 1.01 1.895 1.206-2.152 4.372-3.317 2.394-2.784 2.018-3.91.356-4.66-.277-2.27-6.133-.336-13.472.336Z",
    fill: "#D12C46"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.226 79.524s3.956-1.698 3.976-5.41M15.179 79.524s-3.957-1.698-3.977-5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.281 88.034c4.851 0 8.784-3.925 8.784-8.767S16.132 70.5 11.28 70.5c-4.85 0-8.783 3.925-8.783 8.767s3.932 8.767 8.783 8.767Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.873 17.939S-.33 32.669 1.825 38.454c2.987 8.016 9.377 5.548 9.377 13.348v23.22M19.55 17.939s3.206 14.73 1.05 20.515c-2.988 8.016-9.378 5.548-9.378 13.348",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.281 29.371c4.851 0 8.784-3.925 8.784-8.766 0-4.842-3.933-8.767-8.784-8.767-4.85 0-8.783 3.925-8.783 8.767 0 4.841 3.932 8.766 8.783 8.766Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.333 39.678c2.829-5.173 8.309-8.688 14.639-8.688 6.331 0 11.653 3.416 14.501 8.471 1.365 2.409-30.426 2.587-29.14.237v-.02Z",
    fill: "#8D2215"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m154.788 39.994 2.156 3.14 2.968 2.33 4.134 1.915 3.878 2.448 1.127 1.224 1.504-1.658 3.917-2.212s5.361-2.073 5.421-2.25c.059-.178 2.354-3.16 2.354-3.16l1.028-1.876-4.134-2.191-15.154-.534-9.219 2.785.02.04Z",
    fill: "#8D2215"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M169.071 48.346c-11.454-1.263-15.569-7.167-15.569-14.078",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M153.502 34.288c0-2.666 1.741-8.648 2.097-10.445.613-3.14.455-10.248.455-10.248M165.095 47.596s3.956 1.698 3.976 5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M173.028 47.596s-3.957 1.698-3.977 5.41M169.071 51.565V70.42M169.071 87.48c6.785 0 12.286-5.489 12.286-12.26 0-6.773-5.501-12.262-12.286-12.262-6.785 0-12.285 5.49-12.285 12.261 0 6.772 5.5 12.262 12.285 12.262Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M165.095 74.923s3.956-1.698 3.976-5.41",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M173.028 74.923s-3.957-1.698-3.977-5.41M168.814 48.346c11.454-1.263 15.569-7.167 15.569-14.078",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M184.383 34.288c0-2.666-1.741-8.648-2.097-10.445-.613-3.14-.455-10.248-.455-10.248",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.972 27.259c7.135 0 12.919-5.773 12.919-12.894 0-7.12-5.784-12.893-12.919-12.893-7.134 0-12.918 5.772-12.918 12.893 0 7.12 5.784 12.894 12.918 12.894Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m119.554 43.212 2.137 3.258 3.027 3.95 1.721 3.12.87 1.5.712-1.52 2.592-4.068 3.798-5.41.475-2.192-4.372-2.745s-4.253-.256-4.471-.236c-.218.02-5.856 2.053-5.856 2.053l-.633 2.31v-.02Z",
    fill: "#FCEEAB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M119.06 41.85c1.938-2.192 4.906-3.593 8.249-3.593 3.343 0 6.133 1.322 8.072 3.396 1.582 1.698-17.785 1.856-16.321.197Z",
    fill: "#FCEEAB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M123.333 82.466s3.956-1.935 3.976-6.16M131.285 82.466s-3.956-1.935-3.976-6.16",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M127.309 89.653c5.376 0 9.733-3.987 9.733-8.905 0-4.918-4.357-8.905-9.733-8.905-5.375 0-9.733 3.987-9.733 8.905 0 4.918 4.358 8.905 9.733 8.905ZM127.309 76.305V57.863M127.289 17.8c3.715 0 6.727-2.749 6.727-6.14 0-3.391-3.012-6.14-6.727-6.14-3.715 0-6.726 2.749-6.726 6.14 0 3.391 3.011 6.14 6.726 6.14Z",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.956 12.035s4.906 20.436 2.73 27.011c-2.987 9.142-9.377 10.623-9.377 19.489",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M120.583 12.035s-4.807 20.436-2.651 27.011c2.987 9.142 9.377 10.623 9.377 19.489",
    stroke: "#fff",
    strokeWidth: 1.43,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgBicchieriIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/37e4350c5cce2bb329b55e240f8e4bd9.svg";